import ReactMarkdown from 'react-markdown';
import { uuid } from 'uuidv4';

import { Markdown } from '@/lib/types';

export default function MarkdownRenderer(props: Markdown) {
  return (
    <div id={props.slug || uuid()}>
      <ReactMarkdown className='freeform-content'>
        {props.content}
      </ReactMarkdown>
    </div>
  );
}
